import { version } from "../../package.json"

export const environment = {
    production: false,
    appVersion: version,
    LOG_LEVEL: "debug",
    analyticsUrl: "https://analytics.logickapps.co",
    api: {
        basePath: "https://internal-dev.api.logickapps.co",
        credentials:{
            apiKey: "dev-01KFJKT1RDNTWV861Q51XKDFW1",
            clientId: "dev-01KJ7AQSPRRAG0Q90EA76RMT3V"
        },
        loginRedirect: "/login"
    }
}
